"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useWranglerDataContext = exports.WranglerDataContext = void 0;
var react_1 = __importStar(require("react"));
var WranglerDataSource_1 = __importDefault(require("./WranglerDataSource"));
var use_deep_compare_effect_1 = __importDefault(require("use-deep-compare-effect"));
exports.WranglerDataContext = react_1.createContext(undefined);
function WranglerDataProvider(props) {
    var _a = react_1.useState(undefined), wranglerData = _a[0], setWranglerData = _a[1];
    var _b = react_1.useState(false), updating = _b[0], setUpdating = _b[1];
    var _c = react_1.useState([]), exceptionMessages = _c[0], setExceptionMessages = _c[1];
    // The set of properties that this useEffect are dependent on. We ignore children which is
    // just passed along through the provider.
    var children = props.children, useEffectProps = __rest(props, ["children"]);
    var context = {
        merchant: useEffectProps.merchant,
        culture: useEffectProps.culture,
        initialSelectedAttributes: useEffectProps.initialSelectedAttributes,
        initialQuantity: useEffectProps.selectedQuantity,
        merchandisingExperience: useEffectProps.merchandisingExperience,
        merchAttr: useEffectProps.merchAttr,
        includeVat: useEffectProps.includeVat,
        priceStyle: useEffectProps.priceStyle,
        couponCode: useEffectProps.couponCode,
        pricingContextString: useEffectProps.pricingContextString,
        excludeInitialSelectedAttributes: useEffectProps.excludeInitialSelectedAttributes,
        deselectCompletedOptions: useEffectProps.deselectCompletedOptions,
        selectedAttributes: useEffectProps.selectedAttributes,
    };
    use_deep_compare_effect_1.default(function () {
        var mounted = true;
        function requestWranglerData() {
            return __awaiter(this, void 0, void 0, function () {
                var req, getResponse, err_1;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            _a.trys.push([0, 2, , 3]);
                            req = __assign({}, useEffectProps);
                            return [4 /*yield*/, WranglerDataSource_1.default.getWranglerData(req, useEffectProps.wranglerHost)];
                        case 1:
                            getResponse = _a.sent();
                            if (mounted) {
                                setExceptionMessages(getResponse.exceptionMessages);
                                setUpdating(false);
                                setWranglerData(getResponse.data || wranglerData);
                            }
                            return [3 /*break*/, 3];
                        case 2:
                            err_1 = _a.sent();
                            if (mounted) {
                                setExceptionMessages([err_1.message + ": " + err_1.stack]);
                                setUpdating(false);
                            }
                            return [3 /*break*/, 3];
                        case 3: return [2 /*return*/];
                    }
                });
            });
        }
        if (wranglerData) {
            setUpdating(true);
        }
        requestWranglerData();
        return function () {
            mounted = false;
        };
    }, [useEffectProps]);
    return react_1.default.createElement(exports.WranglerDataContext.Provider, { value: {
            data: wranglerData,
            context: context,
            updating: updating,
            exceptionMessages: exceptionMessages
        } }, props.children);
}
exports.default = WranglerDataProvider;
;
/** Uses the wrangler data provider */
var useWranglerDataContext = function () {
    return react_1.useContext(exports.WranglerDataContext);
};
exports.useWranglerDataContext = useWranglerDataContext;
//# sourceMappingURL=WranglerDataProvider.js.map